import DateTimeCell from '../cells/datetime';

export const dateTimeBodyRender =
  (hideDate?: boolean, hideTime?: boolean) =>
  // eslint-disable-next-line react/display-name
  (value: string | null | undefined) => {
    return (
      <>
        {value ? (
          <DateTimeCell value={value} hideDate={hideDate} hideTime={hideTime} />
        ) : (
          <span>не указано</span>
        )}
      </>
    );
  };
